import { Injectable } from '@angular/core';

import { ClientConfigProductName, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';

import { ClientTagManager } from './tracking.models';

@LazyClientConfig({ key: 'vnTracking', product: ClientConfigProductName.SF })
@Injectable({
    providedIn: 'root',
    deps: [LazyClientConfigService],
    useFactory: trackingConfigFactory,
})
export class TrackingConfig extends LazyClientConfigBase {
    allowlist: string[];
    benchmarkThreshold: number;
    blocklist: string[];
    clientInjectionExcludes: string[];
    clientTagManagers: ClientTagManager[];
    dataLayerName: string;
    dataLayerUpdateTimeoutInMilliseconds: number;
    delayGTM: number;
    deviceBlockEnabled: boolean;
    deviceConcurrency: number;
    deviceMemory: number;
    enableGTM: boolean;
    enableLogging: boolean;
    enableOmitting: boolean;
    eventCallbackTimeoutInMilliseconds: number;
    isEnabled: boolean;
    notTrackedQueryStrings: string[];
    omitAll: boolean;
    omitPercentage: number;
    pageViewDataProviderTimeout: number;
    schedulerEnabled: boolean;
    tagManagerRenderers: string[];
    trackingDelay: number;
}

export function trackingConfigFactory(service: LazyClientConfigService) {
    return service.get(TrackingConfig);
}
